import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL, USERS_API_URL } from '../../../../config';
import brokersAxios from '../../../../utils/axios/brokers-roles.axios';
import { PaginatedChats } from '../../../../interfaces/chat/paginatedStore.type';

const tryToFetchChats = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<PaginatedChats>> => {
    const url = filters
        ? `${USERS_API_URL}/hotel-world-user-invites/user-management-actions?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${USERS_API_URL}/hotel-world-user-invites/user-management-actions?page=${pageNumber}&size=${pageSize}`;
    return brokersAxios.put<PaginatedChats>(url, { filters: data });
};

const tryToFetchAllChats = (): Promise<AxiosResponse<any>> => {
    return brokersAxios.get(`${USERS_API_URL}/hotel-world-user-invites/user-management-actions/all`);
};

const tryToCreateChatMessage = (data: any): Promise<AxiosResponse<any>> => {
    return brokersAxios.post(`${USERS_API_URL}/hotel-world-user-invites/user-management-actions`, data);
};

const tryToUploadChatFiles = (data: any): Promise<AxiosResponse<any>> => {
    return brokersAxios.post(`${USERS_API_URL}/hotel-world-user-invites/upload-chat-files`, data);
};

const tryToCreateChatUserMessage = (data: {
	message: string, 
	files?: {name: string, url: string}[], 
	topic?: string, 
	user: {name: string, email: string, id: string}
}): Promise<AxiosResponse<any>> => {
    return brokersAxios.post(`${DEVICE_INFO_API_URL}/chatbox/chat`, data);
};

const tryToCreateChatUserFileMessage = (data: FormData): Promise<AxiosResponse<any>> => {
    return brokersAxios.post(`${DEVICE_INFO_API_URL}/chatbox/chat`, data);
};

export const ChatsService = {
	tryToCreateChatUserMessage,
	tryToCreateChatUserFileMessage,
    tryToFetchChats,
    tryToFetchAllChats,
    tryToCreateChatMessage,
    tryToUploadChatFiles
};